import { render, staticRenderFns } from "./WhatsNewModal.vue?vue&type=template&id=d4aa6922&scoped=true&"
import script from "./WhatsNewModal.vue?vue&type=script&lang=js&"
export * from "./WhatsNewModal.vue?vue&type=script&lang=js&"
import style0 from "./WhatsNewModal.vue?vue&type=style&index=0&id=d4aa6922&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4aa6922",
  null
  
)

export default component.exports